import './Background4.css';
import bgImage from '../assets/calm-nature-light.jpg';

const Background4 = () => {
  return <div className="nature-background" style={{ backgroundImage: `url(${bgImage})` }}></div>;
};

export default Background4;